import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubCategoryRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-category',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId',
};
